import { createSelector } from '@reduxjs/toolkit';
import { reject } from 'lodash';

// TODO: Why is fetching status stored in an array?
const getFetchingStatus = (state) =>
  (state?.services?.fetchingStatus || [])[0] || {};

const getFerryGrouping = (state) => state?.services?.ferryGrouping || {};

const HANDLED_EXCEPTIONS = ['inventory', 'product_restriction'];

export const buildServices = (services) => {
  if (!services) {
    return [];
  }

  return reject(
    services,
    (service) =>
      !service.bookable && !HANDLED_EXCEPTIONS.includes(service.exception_type)
  );
};

const getFirstFerryGroupingServices = createSelector(
  [getFerryGrouping, getFetchingStatus],
  (ferryGrouping, fetchingStatus) => {
    const firstGrouping = ferryGrouping[0] || {};

    return Object.entries(firstGrouping).reduce((total, pair) => {
      const [key, value] = pair;

      total[key] = {
        services: buildServices(value),
        fetchingStatus: fetchingStatus[key] || false,
      };
      return total;
    }, {});
  }
);

export { getFirstFerryGroupingServices };
